






































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import moment from "moment";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadiumGrounds!: any[];

  @Prop() orderedId!: number;

  @Prop() allowHalfAnHour!: boolean;

  chooseDate() {
    // 选择日期
  }

  disabledDate(current: any) {
    // Can not select days before today and today
    return current && current <= moment().subtract(1, "day").endOf("day");
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;

            const res = await this.$store.dispatch(
              "stadium/editStadiumGroundTimeCost",
              {
                id: this.editId,
                ...values,
              }
            );
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  validateToTimeStart(rule: any, value: any, callback: any) {
    const { form } = this;
    if (
      value &&
      parseInt(value, 10) < parseInt(form.getFieldValue("time_start"), 10)
    ) {
      callback("结束时间不能小于开始时间");
    } else {
      callback();
    }
  }

  validateToTimeEnd(rule: any, value: any, callback: any) {
    const { form } = this;
    if (
      value &&
      parseInt(value, 10) > parseInt(form.getFieldValue("time_end"), 10)
    ) {
      callback("开始时间不能大于结束时间");
    } else {
      callback();
    }
  }

  handleDelete() {
    this.$confirm({
      title: "确认消息",
      content: "确定要删除该占场吗？",
      onOk: async () => {
        const res = await this.$store.dispatch(
          "stadium/deleteStadiumGroundTimeCost",
          {
            id: this.orderedId,
          }
        );
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.handleCancel();
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("stadium/getStadiumGroundTimeCost", {
      id: this.orderedId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
